module.exports = __webpack_public_path__ + "img/804.47c396c0.png";